import { render } from "./ClassicTable.vue?vue&type=template&id=256bc149&scoped=true&ts=true"
import script from "./ClassicTable.vue?vue&type=script&lang=ts"
export * from "./ClassicTable.vue?vue&type=script&lang=ts"

import "./classic-table.scss?vue&type=style&index=0&id=256bc149&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/orangehrm/orangehrm/installer/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-256bc149"]])

export default __exports__